import { createStore } from '@stencil/store';

export interface IMenuUser {
  currentGroup: IWCGroupUser;
  currentUser: IWCUser;
  groups: IWCGroupUser[];
  hasManyGroups: boolean;
  renewsCount: number;
}

const { state } = createStore<IMenuUser>({
  currentGroup: null,
  currentUser: null,
  groups: null,
  hasManyGroups: null,
  renewsCount: 0,
});

export default state;
